// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusTracker-module_wrapper__vabhQ {
    padding-left: 5px;

    &.statusTracker-module_wrapperWithIcon__TSuTT {
        padding-left: 11px;
    }
}

.statusTracker-module_item__TUHAV {
    padding-bottom: 24px;
    padding-left: 26px;
    position: relative;
    border-left: 2px dotted var(--status-tracker-line);

    &.statusTracker-module_inProgress__hPUYW,
    &.statusTracker-module_success__o2w0h {
        border-left: 2px solid var(--status-tracker-accent);
    }

    &:last-child {
        padding-bottom: 0;
        border-color: transparent;
    }

    &:after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 0;
        left: -7px;
        width: 12px;
        height: 12px;
        background: var(--status-tracker-bg);
        border: 2px solid var(--status-tracker-line);
        border-radius: 50%;
        box-sizing: border-box;
    }

    &.statusTracker-module_inProgress__hPUYW:after,
    &.statusTracker-module_success__o2w0h:after {
        background: var(--status-tracker-accent);
        border-color: var(--status-tracker-accent);
    }
}
.statusTracker-module_iconWrapper__IbtIg {
    position: absolute;
    top: -6px;
    left: -13px;
    z-index: 1;
    display: inline-block;
    background: var(--status-tracker-bg);
    border-radius: 50%;
}

.statusTracker-module_item__TUHAV:has(> .statusTracker-module_iconWrapper__IbtIg):after {
    display: none;
}
.statusTracker-module_itemContent__zyoxV {
    top: -6px;
    position: relative;
}

.statusTracker-module_descriptions__gUrp4 {
    margin-top: 8px;
    & p {
        margin-bottom: 16px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/List/styles/statusTracker.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;;IAEjB;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;;IAElD;;QAEI,mDAAmD;IACvD;;IAEA;QACI,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,qBAAqB;QACrB,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,4CAA4C;QAC5C,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;;QAEI,wCAAwC;QACxC,0CAA0C;IAC9C;AACJ;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf;QACI,mBAAmB;QACnB;YACI,gBAAgB;QACpB;IACJ;AACJ","sourcesContent":[".wrapper {\n    padding-left: 5px;\n\n    &.wrapperWithIcon {\n        padding-left: 11px;\n    }\n}\n\n.item {\n    padding-bottom: 24px;\n    padding-left: 26px;\n    position: relative;\n    border-left: 2px dotted var(--status-tracker-line);\n\n    &.inProgress,\n    &.success {\n        border-left: 2px solid var(--status-tracker-accent);\n    }\n\n    &:last-child {\n        padding-bottom: 0;\n        border-color: transparent;\n    }\n\n    &:after {\n        content: '';\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: -7px;\n        width: 12px;\n        height: 12px;\n        background: var(--status-tracker-bg);\n        border: 2px solid var(--status-tracker-line);\n        border-radius: 50%;\n        box-sizing: border-box;\n    }\n\n    &.inProgress:after,\n    &.success:after {\n        background: var(--status-tracker-accent);\n        border-color: var(--status-tracker-accent);\n    }\n}\n.iconWrapper {\n    position: absolute;\n    top: -6px;\n    left: -13px;\n    z-index: 1;\n    display: inline-block;\n    background: var(--status-tracker-bg);\n    border-radius: 50%;\n}\n\n.item:has(> .iconWrapper):after {\n    display: none;\n}\n.itemContent {\n    top: -6px;\n    position: relative;\n}\n\n.descriptions {\n    margin-top: 8px;\n    & p {\n        margin-bottom: 16px;\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `statusTracker-module_wrapper__vabhQ`,
	"wrapperWithIcon": `statusTracker-module_wrapperWithIcon__TSuTT`,
	"item": `statusTracker-module_item__TUHAV`,
	"inProgress": `statusTracker-module_inProgress__hPUYW`,
	"success": `statusTracker-module_success__o2w0h`,
	"iconWrapper": `statusTracker-module_iconWrapper__IbtIg`,
	"itemContent": `statusTracker-module_itemContent__zyoxV`,
	"descriptions": `statusTracker-module_descriptions__gUrp4`
};
export default ___CSS_LOADER_EXPORT___;
